<template>
  <div style="margin-top:20px;">
    <h5 class="mx-auto" style="margin-top:10px;">予期せぬエラーが発生しました</h5>
    <div class="left" style="margin-top:20px;">
      <div>
        <p>時間をおいて再度操作いただくようお願いします。</p>
        <p>それでも改善しない場合は、地域医療連携システム運営までお問い合わせください。</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SystemError",
  created() {
    //TOP画面のボタンを非表示に設定
    this.$store.commit("setIsShowNextBtn", false);
    //初期化済みを通知
    this.$store.commit("setIsInitialized", true);
  }
};
</script>
<style scoped>
    h5 {
      padding: 0.5em; /*文字周りの余白*/
      color: #010101; /*文字色*/
      background: #eaf3ff; /*背景色*/
      border-bottom: solid 3px #516ab6; /*下線*/
      text-align: center;
    }
</style>
